import api from "./Axios";

/**
 * Fire-and-forget CTA click tracking. Proxied through the website backend
 * (which injects the v2 website API key) — see the Website Visit Handoff
 * integration contract.
 */
export const recordPricingClickEvent = async (payload) => {
  try {
    const response = await api.post("/pricing/events/", payload);
    return response?.data?.success ? response.data : false;
  } catch (error) {
    console.error("Error recording pricing click event:", error);
    return false;
  }
};
